import { Attribute } from "../../../api/models/attribute";
import React, { useEffect, useState } from "react";
import { fetchDimensionAttribute } from "../../../api/object/Dimensions";
import { Dropdown, IDropdownOption, ResponsiveMode } from "@fluentui/react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";

export const AttributeSelect = ({
  dimensionOid,
  dbId,
  onChange,
  selectedKey,
  disabled,
}: {
  dimensionOid: string | undefined;
  dbId: string;
  onChange: (i: Attribute) => void;
  selectedKey: string | undefined;
  disabled: boolean;
}) => {
  const [availableAttributes, setAvailableAttributes] = useState<Attribute[]>([]);

  useEffect(() => {
    if (dimensionOid && availableAttributes[0]?.dimensionOid !== dimensionOid) {
      fetchDimensionAttribute(dbId, dimensionOid)
        .then((attributes) => {
          setAvailableAttributes(attributes.filter((a) => a.visible));
        })
        .catch((e) => {
          // eslint-disable-next-line no-undef
          console.error(e);
        });
    }
  }, [dimensionOid, dbId]);

  function onChooseAttribute(option: IDropdownOption) {
    onChange(availableAttributes.find((d) => d.code === option.key));
  }

  return (
    <Dropdown
      id="attribute_dropdown"
      placeholder={formatMessage("cof.objectsource.placeholder.attribute")}
      label={formatMessage("cof.objectsource.attribute")}
      options={availableAttributes.map((d) => ({ key: d.code, text: d.name }))}
      onChange={(_event, option) => onChooseAttribute(option)}
      selectedKey={selectedKey ?? null}
      responsiveMode={ResponsiveMode.large}
      disabled={disabled}
      required
    />
  );
};
